module.exports = __webpack_public_path__ + "static/media/paraglide1.3a2c46af.png";